// src/data/projects.js

import salesPilotImg from "../Assets/Projects/salesPilot/Screenshot 2026-01-28 132124.png";

import addvey1 from "../Assets/Projects/addvey/addvey-1.PNG";
import addvey2 from "../Assets/Projects/addvey/addvey-2.PNG";
import addvey3 from "../Assets/Projects/addvey/addvey-3.PNG";
import addvey4 from "../Assets/Projects/addvey/addvey-4.PNG";
import addvey5 from "../Assets/Projects/addvey/addvey-5.PNG";

import scalepilotImg from "../Assets/Projects/scalepilot.PNG";
// import lanalifeCareImg from "../Assets/Projects/lanalifeCare.PNG";
import giftCard from "../Assets/Projects/Gift Card.PNG";
import carRental from "../Assets/Projects/car-rental.PNG";


// import realStateUser1 from "../Assets/Projects/real_estate_user/Image1.png";
// import realStateUser2 from "../Assets/Projects/real_estate_user/Image2.png";

// import realStateAdmin1 from "../Assets/Projects/Real_Estate_Admin/image1.png";
// import realStateAdmin2 from "../Assets/Projects/Real_Estate_Admin/image2.png";
// import realStateAdmin3 from "../Assets/Projects/Real_Estate_Admin/image3.png";


// import oldageHomeCare1 from "../Assets/Projects/Charity/image1.png";
// import oldageHomeCare2 from "../Assets/Projects/Charity/image2.png";
// import oldageHomeCare3 from "../Assets/Projects/Charity/image3.png";
// import oldageHomeCare4 from "../Assets/Projects/Charity/image4.png";

import ntMomineen from "../Assets/Projects/Momaneen/home.PNG";
import aseAthletics from "../Assets/Projects/ASE/ASE.PNG";
import xenovaHealthcare from "../Assets/Projects/Xena/Capture.PNG";  
import purposefulPetals from "../Assets/Projects/purposeFull/Capture.PNG";
import machanicOnCall from "../Assets/Projects/MachanicOnCall/home.PNG";
import iSolutions from "../Assets/Projects/iSolutions/iSolutions.PNG";

import voxenon from "../Assets/Projects/Voxinon/Image1.PNG";
import voxenon1 from "../Assets/Projects/Voxinon/Image2.PNG";
import voxenon2 from "../Assets/Projects/Voxinon/Image3.PNG";
import voxenon3 from "../Assets/Projects/Voxinon/Image4.PNG";
import voxenon4 from "../Assets/Projects/Voxinon/Image5.PNG";

import { SiNodedotjs } from "react-icons/si";
import { FaShieldAlt, FaRocket, FaBug, FaCloud, FaCode } from "react-icons/fa";

export const projects = [
  {
    id: 0,
    slug: "voxenon",
    projectName: "Voxenon",
    title: "Voxenon - AI Voice Studio Platform",
    short_description:
      "Full-featured AI voice platform inspired by ElevenLabs — voice generation, multi-speaker podcasts, background noise removal, and audio extraction from video.",
    role: "Frontend Developer & Co-Ideator",
    long_description:
      "Voxenon is a professional AI-powered voice studio platform inspired by ElevenLabs, built to give creators and businesses a complete toolkit for audio production. I contributed as a Frontend Developer and also played a key role in shaping the product idea from the ground up. The platform is built with a dynamic, secure, and high-performance architecture, delivering a seamless studio-grade experience in the browser. Features span from AI voice generation and multi-speaker podcast creation to voice background noise removal and audio extraction from video files. The platform is currently in active development with payment integration as the next milestone.",
    problem:
      "Creators and businesses lacked an affordable, all-in-one browser-based voice studio combining AI voice generation, podcast production, and audio editing tools in a single professional platform.",
    solution:
      "Built a comprehensive AI voice studio with a fast, dynamic, and secure frontend covering the full audio creation workflow — from generating voices to cleaning and extracting audio — all in one professional platform.",
    implementation: [
      "Dynamic React frontend with performance-optimized architecture",
      "AI voice generation integration with multi-voice support",
      "Multi-speaker podcast creation workflow",
      "Voice background noise removal module",
      "Audio extraction from video files",
      "Secure API integration with authentication system",
      "Responsive and accessible UI for all screen sizes",
    ],
    features: [
      "AI Voice Generation — generate realistic voices from text",
      "Multi-Speaker Podcast Creator — produce conversations with multiple AI voices",
      "Voice Background Removal — clean background noise from recordings",
      "Audio Extraction from Video — pull audio tracks from uploaded video files",
      "Studio-quality audio output",
      "Secure and fast user experience",
      "Professional dynamic UI with real-time feedback",
      "Payment integration (coming soon)",
    ],
    tech_stack: ["React", "JavaScript", "CSS", "REST APIs", "AI Integration"],
    website: "https://voxenon-production-frontend.vercel.app/",
    live_url: "https://voxenon-production-frontend.vercel.app/",
    github_url: null,
    location: "Remote",
    screenshots: [voxenon, voxenon1, voxenon2, voxenon3, voxenon4],
    status: "featured",
    cta:
      "If you're building an AI-powered SaaS or creative tool and need a high-quality frontend, let's connect and build something great.",
    enabled_all: true,
  },

  {
    id: 1,
    slug: "sales-pilot",
    projectName: "Sales Pilot",
    title: "Sales Pilot - AI Sales Dashboard",
    short_description:
      "High-performance AI-driven frontend for optimizing sales workflows and lead management.",
    role: "Frontend Angular Developer (Remote)",
    long_description:
      "Sales Pilot is an AI-driven sales platform built to help businesses improve productivity through intelligent workflows and user-friendly dashboards. I worked on developing scalable and high-performance Angular interfaces that seamlessly integrate with backend services, enabling sales teams to manage leads, configure accounts, and track performance efficiently. The focus was on usability, performance optimization, and real-world sales workflows.",
    problem:
      "Sales teams were relying on fragmented tools with poor user experience, leading to inefficient lead management and reduced productivity.",
    solution:
      "I designed and implemented modern, intuitive Angular-based interfaces that streamlined workflows, improved data visibility, and enhanced user engagement across the platform.",
    implementation: [
      "Modular Angular architecture",
      "Optimized sales and account management forms",
      "API integration for real-time data updates",
      "Reusable UI components for scalability",
    ],
    features: [
      "AI-assisted sales workflows",
      "Lead and account management dashboards",
      "Responsive and performance-optimized UI",
      "Clean and intuitive user experience",
    ],
    tech_stack: ["Angular", "TypeScript", "RxJS", "SCSS"],
    website: "https://salespilot.scalepilot.de/account-setting",
    live_url: "https://salespilot.scalepilot.de/account-setting",
    github_url: null,
    location: "Remote",
    screenshots: [salesPilotImg],
    cta:
      "If you are building a SaaS or sales platform and need a frontend that converts users, feel free to connect with me.",
    enabled_all: true,
  },

  {
    id: 2,
    slug: "addvey",
    projectName: "Addvey",
    title: "Addvey - Enterprise Admin Panel",
    short_description:
      "Comprehensive Angular admin dashboard for managing marketplace users, products, and analytics.",
    role: "Frontend Angular Developer",
    long_description:
      "Addvey is a large-scale OLX-inspired marketplace platform where I developed a powerful Angular-based admin panel. The dashboard allows administrators to manage users, listings, categories, and monitor real-time analytics through interactive charts. The system was designed to handle complex data while maintaining performance and ease of use.",
    problem:
      "Managing users, products, and analytics across multiple modules was inefficient due to scattered tools and lack of centralized control.",
    solution:
      "I built a centralized admin dashboard that unified all management modules into a single interface, improving operational efficiency and data visibility.",
    implementation: [
      "Angular admin dashboard architecture",
      "Role-based UI modules",
      "Real-time charts and analytics integration",
      "Scalable component-driven design",
    ],
    features: [
      "User and product management",
      "Category and listing moderation",
      "Real-time analytics and charts",
      "Secure and responsive admin interface",
    ],
    tech_stack: ["Angular", "TypeScript", "Chart.js", "PrimeNG"],
    website: "https://admin.addvey.com/login",
    live_url: "https://admin.addvey.com/login",
    github_url: null,
    location: "Onsite / Remote",
    screenshots: [addvey1, addvey2, addvey3, addvey4, addvey5],
    cta:
      "Need a scalable admin panel or dashboard for your platform? Let’s connect and build it the right way.",
    enabled_all: true,
  },

  {
    id: 3,
    slug: "scalepilot",
    projectName: "Scalepilot",
    title: "Scalepilot - Outreach Automation",
    short_description:
      "Intuitive frontend for automating Instagram outreach campaigns and monitoring performance analytics.",
    role: "Frontend Angular Developer (Remote)",
    long_description:
      "Scalepilot is an AI automation tool that helps businesses scale Instagram outreach campaigns. I worked on designing and implementing intuitive frontend interfaces that allow users to configure campaigns, monitor performance, and analyze results. The goal was to make complex automation flows simple and user-friendly.",
    problem:
      "Manual Instagram outreach was time-consuming, inconsistent, and difficult to scale for growing businesses.",
    solution:
      "I helped build clean and user-friendly frontend interfaces that enabled campaign automation, performance tracking, and efficient outreach management.",
    implementation: [
      "Campaign management UI development",
      "Performance tracking dashboards",
      "Automation flow UX design",
      "Responsive layouts for all devices",
    ],
    features: [
      "Automated Instagram outreach UI",
      "Campaign performance analytics",
      "User-friendly dashboard experience",
      "Scalable Angular frontend",
    ],
    tech_stack: ["Angular", "TypeScript", "SCSS"],
    website: "https://scalepilot.de",
    live_url: "https://scalepilot.de",
    github_url: null,
    location: "Remote",
    screenshots: [scalepilotImg],
    cta:
      "If you’re building an automation or AI-driven product, let’s connect and bring your idea to life.",
    enabled_all: true,
  },

    {
    id: 15,
    slug: "mechanic-on-call",
    projectName: "Mechanic on Call",
    title: "Mechanic on Call - Mobile Automotive Service",
    short_description:
      "Service business website for a certified mobile mechanic company offering doorstep car repairs across Ontario, Canada.",
    role: "WordPress Developer",
    long_description:
      "Mechanic on Call is a mobile automotive service company operating in Ontario, Canada, that brings certified mechanics directly to customers' homes or driveways — eliminating the need for traditional shop visits. They offer routine maintenance, repairs, and specialty services 7 days a week from 9 AM to 9 PM across Kitchener, Waterloo, Cambridge, and surrounding areas. I developed the WordPress website to clearly communicate the business's unique convenience model, service offerings, and booking process to local customers.",
    problem:
      "The business needed a clear and trustworthy website that communicated the doorstep service concept, listed available repairs, and encouraged customers to book appointments over competitors.",
    solution:
      "Built a service-focused WordPress website with structured service listings, booking CTAs, certification highlights, and warranty information to convert local visitors into customers.",
    implementation: [
      "Service listing pages with detailed offerings",
      "Booking and contact inquiry integration",
      "Operating hours and service area information",
      "Trust signals: certifications and warranty details",
      "Mobile-responsive design for on-the-go users",
    ],
    features: [
      "Doorstep car repair service showcase",
      "Routine maintenance and repair service listings",
      "7-day availability and operating hours display",
      "Service area coverage for Kitchener, Waterloo, Cambridge",
      "Warranty and certification trust badges",
    ],
    tech_stack: ["WordPress", "Elementor", "CSS", "SEO"],
    website: "https://mechaniconcall.ca/",
    live_url: "https://mechaniconcall.ca/",
    github_url: null,
    location: "Remote",
    screenshots: [machanicOnCall],
    cta:
      "Need a local service business website that converts visitors into customers? Let's build it.",
    enabled_all: true,
  },

  {
    id: 12,
    slug: "xenova-healthcare",
    projectName: "Xenova Healthcare",
    title: "Xenova Healthcare - Pharmaceutical Commercialization Platform",
    short_description:
      "Corporate website for a healthcare platform licensing advanced medicines across the Middle East and Africa.",
    role: "WordPress Developer",
    long_description:
      "Xenova Healthcare is a first-in-class commercialization platform bringing advanced medicines to over 21 countries across the Middle East and Africa. The organization licenses innovative therapies from global pharmaceutical companies and manages distribution, clinical research, and hospital relationships across underserved markets. I developed the corporate WordPress website to reflect the organization's mission-driven brand, global reach, and professional credibility in the pharmaceutical industry.",
    problem:
      "The organization needed a professional corporate website that communicated its mission, geographic presence, and business model to international pharmaceutical partners and healthcare stakeholders.",
    solution:
      "Built an authoritative corporate WordPress website with clear service storytelling, regional presence highlights, and partner-facing content designed to build trust with global pharmaceutical companies.",
    implementation: [
      "Corporate WordPress theme customization",
      "Service and geography-focused page structure",
      "Mission and impact content sections",
      "Multilingual-ready layout",
      "SEO optimization for pharmaceutical industry terms",
    ],
    features: [
      "Pharmaceutical commercialization service showcase",
      "21+ country presence and geographic coverage",
      "Hospital, pharmacy, and lab distribution highlights",
      "Partner and investor-facing corporate content",
      "Mobile-responsive professional design",
    ],
    tech_stack: ["WordPress", "Elementor", "CSS", "SEO"],
    website: "https://xenovahealthcare.com/",
    live_url: "https://xenovahealthcare.com/",
    github_url: null,
    location: "Remote",
    screenshots: [xenovaHealthcare],
    cta:
      "Building a corporate or healthcare platform that needs to communicate trust and global reach? Let's connect.",
    enabled_all: true,
  },
  {
    id: 13,
    slug: "ase-athletics",
    projectName: "ASE Athletics",
    title: "ASE Athletics - African Sports Talent Platform",
    short_description:
      "Sports innovation platform website bridging African athletic talent with global opportunities through education and analytics.",
    role: "WordPress Developer",
    long_description:
      "ASE Athletics is a sports innovation platform born from the African School of Economics, headquartered in Madrid with operations across Africa. The organization bridges the gap for African sports talent through an integrated ecosystem of education, AI-powered analytics, and talent placement services. Their offerings include sports business management programs, the Savvyo Analytics Suite for video analysis and talent identification, and international athlete placement programs. I developed the WordPress website to showcase the platform's three pillars and connect athletes, clubs, and scouts across the globe.",
    problem:
      "African sports talent lacked a centralized digital platform to discover educational programs, access analytics tools, and connect with international clubs and universities.",
    solution:
      "Developed a dynamic WordPress website clearly presenting the three service pillars — academia, analytics, and talent placement — with partnership highlights and ambassador features to build credibility.",
    implementation: [
      "Multi-section WordPress page architecture",
      "Service pillar pages for Academia, Analytics, and Talent Placement",
      "Partnership and ambassador showcase sections",
      "Contact and inquiry integration",
      "Mobile-responsive layout for global audience",
    ],
    features: [
      "Sports Business Academia program listings",
      "Savvyo AI analytics suite overview",
      "International talent placement service pages",
      "Partner and ambassador profiles",
      "Multi-country reach with Madrid hub presence",
    ],
    tech_stack: ["WordPress", "Elementor", "CSS", "SEO"],
    website: "https://aseathletics.com/",
    live_url: "https://aseathletics.com/",
    github_url: null,
    location: "Remote",
    screenshots: [aseAthletics],
    cta:
      "Need a powerful platform website for a sports, education, or talent business? Let's build it together.",
    enabled_all: true,
  },
  {
    id: 14,
    slug: "nt-momineen",
    projectName: "NT Momineen",
    title: "NT Momineen - Community & Religious Organization",
    short_description:
      "Non-profit community website for a Shia Muslim organization serving over 100 members in Darwin, Australia.",
    role: "WordPress Developer",
    long_description:
      "Northern Territory Momineen Incorporated (NTMI) is a registered non-profit serving the Shia Ithna Asheri Muslim community in Darwin, Australia — bringing together members from India, Pakistan, East Africa, Singapore, Afghanistan, Lebanon, Iraq, Syria, and Iran. The organization provides religious programming, educational events, sports activities, and community gatherings. I developed the WordPress website to serve as a central digital hub for the community — featuring prayer times, event listings, donation functionality, and news updates.",
    problem:
      "The diverse community lacked a centralized online platform for sharing prayer schedules, event announcements, and donation information with members across Darwin.",
    solution:
      "Built an accessible and welcoming WordPress website with prayer time displays, event management, donation integration, and community news to strengthen digital engagement.",
    implementation: [
      "WordPress CMS setup for content management",
      "Event listing and community news sections",
      "Prayer time schedule integration",
      "Online donation functionality",
      "Mobile-responsive design for community accessibility",
    ],
    features: [
      "Community event listings and announcements",
      "Prayer schedule and timing display",
      "Online donation capability",
      "Leadership and committee information",
      "Social media and Facebook integration",
    ],
    tech_stack: ["WordPress", "Elementor", "CSS"],
    website: "https://ntmomineen.org.au/",
    live_url: "https://ntmomineen.org.au/",
    github_url: null,
    location: "Remote",
    screenshots: [ntMomineen],
    cta:
      "Building a non-profit or community organization website? Let's create a platform that brings your community together.",
    enabled_all: true,
  },

//   {
//   id: 4,
//   slug: "real-estate-platform",
//   projectName: "Real Estate Platform",
//   title: "Modern Real Estate Platform - MERN Stack",
//   short_description:
//     "Real estate platform with admin dashboard, analytics, and pixel-perfect responsive UI.",
//   role: " MERN Stack Developer",
//   long_description:
//     "A complete real estate web platform built using the MERN stack where I developed both frontend and backend from scratch. I converted Figma designs into fully responsive, pixel-perfect React components and built a scalable Node.js + Express backend with MongoDB. The platform includes an admin dashboard for managing categories, properties, and analytics, along with a user-facing interface for browsing listings and submitting inquiries.",
//   problem:
//     "Real estate businesses needed a centralized platform to manage properties, categories, and customer inquiries while maintaining a modern and high-performance user experience.",
//   solution:
//     "I developed a secure and scalable MERN-based platform with a powerful admin dashboard and an optimized frontend to ensure smooth browsing, efficient management, and improved lead handling.",
//   implementation: [
//     "Designed MongoDB schema for properties, categories, and contacts",
//     "Built RESTful APIs using Node.js and Express",
//     "Converted Figma designs into pixel-perfect React components",
//     "Implemented secure authentication and protected admin routes using JWT",
//     "Built reusable UI component system for scalability and maintainability",
//   ],
//   features: [
//      "Secure admin login and protected routes",
//     "Authenticated Admin can manage property records efficiently",
//     "Full CRUD operations for properties and categories",
//     "Analytics overview for admin insights",
//     "Integrated contact inquiry system",
//     "Fully responsive across mobile, tablet, and desktop",
//       "Deployed frontend on Vercel for fast global delivery",
//     "Used MongoDB Atlas cluster and Cloudinary for media handling"
//   ],
//   tech_stack: [
//     "React",
//     "Node.js",
//     "Express",
//     "MongoDB",
//     "Styled Components",
//     "JWT Authentication",
//   ],
//   website: "https://real-estate-neon-ten.vercel.app/",
//   live_url: "https://real-estate-neon-ten.vercel.app/",
//   github_url: null,
//   location: "Full Stack Development",
//   screenshots: [realStateUser1,realStateUser2],
//   cta:
//     "If you're looking for a scalable real estate or listing platform built with modern technologies, let's connect.",
//   enabled_all: true,
// },
// {
//   id: 5,
//   slug: "real-estate-admin-dashboard",
//   projectName: "Real Estate Admin Panel",
//   title: "Real Estate Admin Dashboard - MERN Stack",
//   short_description:
//     "Secure and scalable admin dashboard for managing properties, categories, and customer inquiries.",
//   role: " MERN Stack Developer",
//   long_description:
//     "A admin dashboard built for managing a real estate platform. I developed a secure and scalable system where administrators can control property listings, manage categories, monitor inquiries, and analyze platform performance. The dashboard was built with React for a dynamic UI and Node.js + Express backend with MongoDB for secure data handling.",
//   problem:
//     "Real estate businesses needed a centralized control panel to efficiently manage listings, categories, and customer leads without relying on third-party tools.",
//   solution:
//     "Built a secure admin dashboard with full CRUD functionality, analytics insights, and protected authentication to streamline internal operations.",
//   implementation: [
//     "Designed database schema for properties, categories, and contact inquiries",
//     "Implemented JWT-based admin authentication and route protection",
//     "Built RESTful APIs for CRUD operations",
//     "Integrated image upload and media management system",
//     "Created analytics overview for monitoring listings and inquiries",
//     "Developed reusable and responsive UI components",
//   ],
//   features: [
//     "Secure admin login and protected routes",
//     "Create, update, delete property listings",
//     "Upload and manage property images and videos",
//     "Add and manage property categories",
//     "View and manage customer contact inquiries",
//     "View dashboard analytics and system insights",
//   ],
//   tech_stack: [
//     "React",
//     "Node.js",
//     "Express",
//     "MongoDB",
//     "JWT Authentication",
//     "Styled Components",
//   ],
//   website: "https://real-estate-admin-phi.vercel.app/",
//   live_url: "https://real-estate-admin-phi.vercel.app/",
//   github_url: null,
//   location: "Full Stack Development",
//   screenshots: [realStateAdmin1, realStateAdmin2, realStateAdmin3],
//   cta:
//     "If you need a custom admin dashboard to manage your business operations efficiently, let's build it together.",
//   enabled_all: true,
// },
//   {
//     id: 6,
//     slug: "lana-life-care",
//     projectName: "Lana Life Care",
//     title: "Lana Life Care - Healthcare Platform",
//     short_description:
//       "Responsive healthcare interface focused on patient engagement and seamless appointment booking.",
//     role: "Frontend Developer",
//     long_description:
//       "Lana Life Care is a Middle East healthcare platform focused on improving digital patient engagement. I worked on building responsive frontend pages, optimizing UI/UX, and integrating backend APIs to ensure smooth and reliable user experiences across devices.",
//     problem:
//       "The platform lacked responsiveness and had poor user experience, negatively impacting patient engagement.",
//     solution:
//       "I rebuilt frontend components with a responsive-first approach and optimized UI/UX to deliver a clean, accessible, and user-friendly healthcare platform.",
//     implementation: [
//       "Responsive UI development",
//       "Backend API integration",
//       "UX optimization for healthcare users",
//       "Performance and accessibility improvements",
//     ],
//     features: [
//       "Fully responsive layouts",
//       "API-driven frontend components",
//       "Improved patient engagement flow",
//       "Clean and accessible design",
//     ],
//     tech_stack: ["JavaScript", "HTML", "CSS", "REST APIs"],
//     website: "https://crm.lanalifecare.com/login",
//     live_url: "https://crm.lanalifecare.com/login",
//     github_url: null,
//     location: "Middle East",
//     screenshots: [lanalifeCareImg],
//     cta:
//       "Healthcare platforms require trust and clarity—if you’re building one, feel free to connect with me.",
//     enabled_all: true,
//   },
  {
    id: 7,
    slug: "gift-card",
    projectName: "Gift Card",
    title: "Gift Card - Gifting Platform",
    short_description:
      "Secure digital platform for generating and sending branded gift cards with a smooth user flow.",
    role: "Frontend Developer",
    long_description:
      "Gift Card Platform is a web application that enables users to generate and send digital gift cards from well-known brands such as Netflix, Starlink, and other popular services. I was responsible for building the complete frontend interface, focusing on user experience, responsiveness, and a smooth card generation workflow. The UI was designed to make the gifting process simple, intuitive, and secure.",
    problem:
      "Users needed a simple and seamless way to generate and send branded gift cards without complex steps or confusing interfaces.",
    solution:
      "I developed a clean, user-friendly frontend that guides users through selecting brands, customizing gift cards, and completing the gifting process efficiently.",
    implementation: [
      "Responsive UI design",
      "Reusable card components",
      "Brand selection interface",
      "Interactive gift card preview",
    ],
    features: [
      "Generate digital gift cards",
      "Multiple brand options (Netflix, Starlink, etc.)",
      "Smooth checkout interface",
      "Mobile-friendly design",
    ],
    tech_stack: ["Angular", "HTML", "CSS"],
    website: null,
    live_url: null,
    github_url: null,
    location: "onSite",
    screenshots: [giftCard],
    cta:
      "If you're looking to build a digital gifting platform with a smooth user experience, feel free to connect with me.",
    enabled_all: true,
  },

  {
    id: 8,
    slug: "car-rental-platform",
    projectName: "Car Rental Platform",
    title: "Car Rental - Booking Marketplace",
    short_description:
      "Modern car rental marketplace enabling companies to list vehicles and customers to book securely.",
    role: "Frontend Developer",
    long_description:
      "Car Rental Platform is a web-based marketplace where rental companies can create showrooms and list their vehicles for customers. Users can browse available cars, submit identification details, and complete secure payments to rent vehicles. I developed the complete frontend UI, ensuring a modern design, responsive layout, and smooth booking flow.",
    problem:
      "Car rental businesses needed a digital platform to showcase vehicles and allow customers to rent them easily online.",
    solution:
      "I built an intuitive frontend interface that allows companies to manage listings and enables users to browse, verify identity, and rent cars seamlessly.",
    implementation: [
      "Dynamic car listing UI",
      "Company showroom interface",
      "Rental booking workflow",
      "Responsive design for all devices",
    ],
    features: [
      "Company showroom creation",
      "Vehicle listing system",
      "Secure booking interface",
      "ID verification submission",
      "Online payment flow UI",
    ],
    tech_stack: ["Angualar", "HTML", "SCSS", "NgPrime"],
    website: null,
    live_url: null,
    github_url: null,
    location: "onSite",
    screenshots: [carRental],
    cta:
      "If you need a modern frontend for a rental or marketplace platform, I’d be happy to collaborate.",
    enabled_all: true,
  },
//   {
//   id: 9,
//   slug: "oldage-home-care",
//   projectName: "Oldage Home Care",
//   title: "Oldage Home Care - Charity & Elder Support Platform",
//   short_description:
//     "Public-facing charity platform with donation system and a secure admin dashboard for managing activities and gallery content.",
//   role: "MERN Stack Developer",
//   long_description:
//     "Oldage Home Care platform built to support elderly care initiatives. The website allows visitors to learn about the organization, explore activities, view galleries, and submit donations or inquiries. A lightweight, secure admin dashboard enables authorized staff to manage activities, gallery images, and donation records efficiently. The system focuses on transparency, simplicity, and responsive design.",
//   problem:
//     "Elderly care organizations needed a modern digital platform to showcase their work, collect donations, and manage content without technical complexity.",
//   solution:
//     "Developed a public charity website with a secure admin panel that allows internal staff to manage activities and gallery content while keeping the user experience simple and accessible.",
//   implementation: [
//     "Designed MongoDB schema for donations, activities, gallery, and contact inquiries",
//     "Built RESTful APIs using Node.js and Express",
//     "Implemented JWT-based admin authentication",
//     "Created responsive React frontend from design",
//     "Integrated secure donation and contact form handling"
//   ],
//   public_functionality: [
//     "View About Us and mission section",
//     "Browse elderly care activities",
//     "View photo gallery",
//     "Submit donation through form",
//     "Send contact inquiry",
//     "Fully responsive across devices"
//   ],
//   admin_functionality: [
//     "Secure admin login",
//     "Add, update, delete activities",
//     "Upload and manage gallery images",
//     "View donation records",
//     "Manage contact inquiries"
//   ],
//   features: [
//     "Public-facing charity platform",
//     "Secure admin dashboard",
//     "Donation tracking system",
//     "Activity & gallery management",
//     "RESTful API architecture",
//     "Responsive UI design"
//   ],
//   tech_stack: [
//     "React",
//     "Node.js",
//     "Express",
//     "MongoDB",
//     "JWT Authentication",
//     "Styled Components"
//   ],
//   website: "https://oldage-home-charity-frontend.vercel.app/",
//   live_url: "https://oldage-home-charity-frontend.vercel.app/",
//   github_url: null,
//   location: "Full Stack Development",
//   screenshots: [oldageHomeCare1, oldageHomeCare2, oldageHomeCare3, oldageHomeCare4],
//   cta:
//     "If you need a secure and scalable charity platform with an easy-to-manage admin system, let's collaborate.",
//   enabled_all: true,
// }

  {
    id: 10,
    slug: "i-solutions-agency",
    projectName: "I-Solutions Marketing Agency",
    title: "I-Solutions - Real Estate Google Ads Agency",
    short_description:
      "Professional agency website for a Google Ads and PPC firm specializing in real estate lead generation.",
    role: "WordPress Developer",
    long_description:
      "I-Solutions Marketing is a specialized Google Ads agency serving real estate investors, wholesalers, and agents. The website was built to reflect the agency's expertise and credibility — combining a clean service-focused layout with compelling calls to action. Founded by Yogev Lifchin with 15+ years of PPC experience and direct real estate investing background, the site communicates the agency's unique positioning as both marketers and investors. I developed and customized this WordPress site to match the agency's brand identity and conversion goals.",
    problem:
      "The agency needed a high-converting website that communicated its niche expertise in real estate PPC to prospects while establishing trust and encouraging consultation bookings.",
    solution:
      "Built a professional WordPress website with a clean layout, service breakdowns, lead capture forms, and strategic CTAs aligned with the agency's 90-day growth sprint offer.",
    implementation: [
      "Custom WordPress theme setup and configuration",
      "Service pages and campaign overview sections",
      "Lead capture and consultation booking integration",
      "Mobile-responsive layout optimization",
      "SEO-friendly page structure",
    ],
    features: [
      "Google Ads and Facebook Ads service showcase",
      "90-day growth sprint offer landing section",
      "Free PPC audit call-to-action flow",
      "Responsive and performance-optimized design",
      "Founder credibility and trust-building sections",
    ],
    tech_stack: ["WordPress", "Elementor", "CSS", "SEO"],
    website: "https://agency.i-solutions.pro/",
    live_url: "https://agency.i-solutions.pro/",
    github_url: null,
    location: "Remote",
    screenshots: [iSolutions],
    cta:
      "Need a high-converting agency or service website? Let's build one that drives real leads.",
    enabled_all: true,
  },
  {
    id: 11,
    slug: "purposeful-petals-co",
    projectName: "Purposeful Petals Co.",
    title: "Purposeful Petals Co. - Charitable Floral Shop",
    short_description:
      "E-commerce floral shop website for a social enterprise donating 100% of net profits to charity.",
    role: "WordPress Developer",
    long_description:
      "Purposeful Petals Co. is a premium floral arrangement and gift shop that operates as a social enterprise — donating 100% of its net profits to selected charities after covering operational costs. Founded and directed by a Special Operations disabled combat veteran, the business supports organizations like Wounded Warrior Project and the Autism Society. I developed the WordPress e-commerce website to reflect the brand's premium quality while clearly communicating its charitable mission, enabling customers to shop with purpose.",
    problem:
      "The business needed an elegant e-commerce website that balanced premium floral design aesthetics with a compelling charitable mission story to convert compassionate shoppers.",
    solution:
      "Developed a clean, premium WordPress e-commerce site with product pages, mission storytelling, local delivery zones, and charity partner highlights to drive both sales and awareness.",
    implementation: [
      "WooCommerce setup for floral product listings",
      "Charity and mission-focused content sections",
      "Local delivery zone configuration",
      "Gift and occasion category structure",
      "Mobile-responsive and visually appealing layout",
    ],
    features: [
      "Online floral arrangement ordering",
      "Same-day local delivery for Chapel Hill/Durham NC",
      "Charity partner showcase and donation transparency",
      "Gift shop with curated options",
      "Founder story and brand mission section",
    ],
    tech_stack: ["WordPress", "WooCommerce", "Elementor", "CSS"],
    website: "https://purposefulpetalsco.org/",
    live_url: "https://purposefulpetalsco.org/",
    github_url: null,
    location: "Remote",
    screenshots: [purposefulPetals],
    cta:
      "Looking to build a mission-driven e-commerce website that converts and inspires? Let's collaborate.",
    enabled_all: true,
  },
  
];

export const services = [
  {
    id: 1,
    icon: <FaCode />,
    title: "Frontend Development",
    description:
      "Custom, scalable web applications using modern JavaScript frameworks.",
    color: "#6C63FF",
    details: [
      "Frontend development using React, Angular, and Vue.js",
      "Single Page Applications (SPA) and dynamic dashboards",
      "Component-based architecture for long-term scalability",
      "State management using Redux, Context API, RxJS, or Pinia",
      "API integration with secure authentication",
      "Clean, maintainable, and performance-optimized code",
    ],
  },

  {
    id: 2,
    icon: <SiNodedotjs />,
    title: "Backend Development",
    description:
      "Robust server solutions with Node.js, Express, and databases.",
    color: "#68A063",
    details: [
      "RESTful API development using Node.js & Express",
      "MVC architecture for scalable backend systems",
      "Authentication with JWT & role-based authorization",
      "MongoDB & SQL database design and optimization",
      "API validation, error handling, and logging",
      "Secure, production-ready backend services",
    ],
  },
  {
    id: 3,
    icon: <FaBug />,
    title: "Live Website Debugging",
    description:
      "Real-time debugging on live and staging environments.",
    color: "#E63946",
    details: [
      "Debugging live production and staging websites",
      "Fixing console errors, crashes, and broken UI",
      "Resolving API failures and backend issues",
      "Performance bottleneck identification and fixes",
      "Deployment-related bug fixes",
      "Safe fixes without breaking live users",
    ],
  },
  {
    id: 4,
    icon: <FaShieldAlt />,
    title: "Security",
    description:
      "Secure applications following industry best practices.",
    color: "#FF9900",
    details: [
      "JWT-based authentication and authorization",
      "Secure REST APIs and protected routes",
      "Data validation and sanitization",
      "CORS configuration and security headers",
      "Protection against common vulnerabilities",
      "Best practices for secure production deployments",
    ],
  },
  {
    id: 5,
    icon: <FaRocket />,
    title: "Performance",
    description:
      "Fast and optimized applications with smooth user experience.",
    color: "#00D4FF",
    details: [
      "Code splitting and lazy loading strategies",
      "Frontend performance tuning",
      "Optimized API response times",
      "Caching strategies for better load times",
      "Reducing bundle size and unnecessary re-renders",
      "Performance audits and improvements",
    ],
  },
  {
    id: 6,
    icon: <FaCloud />,
    title: "Deployment & DevOps",
    description:
      "Reliable deployment and production-ready environments.",
    color: "#7B61FF",
    details: [
      "Deployment on cloud platforms (Vercel, Netlify, VPS, etc.)",
      "CI/CD pipeline setup",
      "Environment variable and configuration management",
      "Domain and SSL configuration",
      "Production build optimization",
      "Post-deployment support and monitoring",
    ],
  },
];
